import React from "react";
import { Button } from "@my-scoot/component-library-legacy";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import { openPricingPage } from "utils/Utils";
import { Lock } from "@material-ui/icons";
import { useParams } from "react-router-dom";
import { getListingUuidFromUrlParam } from "ui/pages/ThankYou/utils";

export const ManageOfferingsLockBtn = ({
  btnText,
  action = openPricingPage,
}) => {
  const isDesktop = useDesktopMediaQuery();

  const { listing_uuid } = useParams();
  const listingId = getListingUuidFromUrlParam() || listing_uuid;

  return (
    <Button
      variant="outlined"
      className={`!tw-text-black tw-bg-[linear-gradient(124.63deg,#FFD37E_3.13%,#F7AD1E_106.11%)] !tw-p-6 !tw-border-none !tw-rounded ${
        isDesktop ? "!tw-text-[14px]" : ""
      }`}
      startIcon={<Lock className={`tw-text-black`} fontSize="small" />}
      onClick={() => action({ listing_uuid: listingId })}
    >
      {btnText}
    </Button>
  );
};
